import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipTogetherTitle: {
    description: 'shipTogetherDestinationModal.title',
    defaultMessage: 'Combine Shipments',
    id: 'HyJMr0',
  },
  shipTogetherTooltip: {
    description: 'shipTogetherDestinationModal.toolTip',
    defaultMessage: 'The combined shipment will keep the shipping configuration and notes from the shipment you select.',
    id: 'D+URoG',
  },
  shipTogetherItemQuantityLabel: {
    description: 'shipTogetherDestinationModal.totalItemQty',
    defaultMessage: 'Total Item Qty',
    id: 'oDN4Ln',
  },
  shipTogetherCombineButton: {
    description: 'shipTogetherDestinationModal.combine',
    defaultMessage: 'Combine',
    id: 'IQoqFg',
  },
  noCombineShipmentSupportAmazon: {
    description: 'A warning message that Amazon does not support combined shipments outside of Seller Central',
    defaultMessage:
      'Amazon does not directly support shipments for orders combined outside of Seller Central. These shipments might affect your Valid Tracking Rate.',
    id: '/Um/xC',
  },
  packingSlipsErrorTitle: {
    description: 'An error title for combine shipments error caused by different packing slips templates',
    defaultMessage: 'Combine Error - Packing Slips',
    id: 'rV7wz3',
  },
  packingSlipsErrorBody: {
    description:
      'An error message that shipments can not be combined if different packing slip templates are required by merchant who delegated the orders',
    defaultMessage:
      'ShipStation cannot combine orders that require different packing slip templates shared by the merchant who delegated the orders. Please either fulfill these orders separately, or cancel the orders and ask the delegating merchant to combine the orders themselves before delegating back to you.',
    id: 'xPkbM/',
  },
  packingSlipsErrorCancelButton: {
    description: 'Packing Slips error cancel button text',
    defaultMessage: 'Cancel',
    id: 'yNamf/',
  },
});
